"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoSabotage = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const Resources_1 = require("../../Resources");
class EcoSabotage {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.ECO_SABOTAGE;
        this.description = 'Lose all plants except 3 + influence.';
        this.revealedDelegate = PartyName_1.PartyName.GREENS;
        this.currentDelegate = PartyName_1.PartyName.REDS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const plants = player.plants;
            const maxPlants = 3 + turmoil.getPlayerInfluence(player);
            const plantDecrease = Math.max(0, plants - maxPlants);
            player.deductResource(Resources_1.Resources.PLANTS, plantDecrease, { log: true, from: this.name });
        });
    }
}
exports.EcoSabotage = EcoSabotage;
//# sourceMappingURL=EcoSabotage.js.map